import React from "react";
import { getCmsData } from "../../functions";
import SocialIconsGroup from "../social-icons-group/SocialIconsGroup";

const Footer = () => {
  const cmsData = getCmsData("footerDataCMS");
  if (!cmsData) return null;

  const { socialLinks, column1, column2, moreInformation } = cmsData;

  return (
    <footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-3 footer-column">
            <h2>We are social</h2>
            <div className="footer-social-icons-group">
              <SocialIconsGroup data={socialLinks[0]} />
            </div>
          </div>

          <div className="col-6 col-md-6 col-lg-3  footer-column">
            <ul className="footer-links">
              {column1.map((item, index) => (
                <li key={index}>
                  <a href={item.pageURL}>{item.pageName}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-6 col-md-6 col-lg-3 footer-column">
            <span className="divider"></span>
            <ul className="footer-links">
              {column2.map((item, index) => (
                <li key={index}>
                  <a href={item.pageURL}>{item.pageName}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-12 col-lg-3  footer-column">
            <div
              className="more-information"
              dangerouslySetInnerHTML={{
                __html: moreInformation.content,
              }}
            ></div>
          </div>
        </div>

        <div className="row">
          <div className="col-6 col-lg-6 footer-column">
            <p>
              Department of Energy, Environment and Climate Action{" "}
              {String.fromCharCode(169)} {new Date().getFullYear()}
            </p>
          </div>

          <div className="col-12 col-lg-6 footer-column vic-gov-logo-container">
            <a href="https://vic.gov.au">
              {" "}
              <img
                src={require("../../images/logo-vic-simple.svg")}
                className="vic-gov-logo"
                alt="Victorian Government logo"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
